import { useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { StyledAdminAddGroupPoolConfigForm } from './styles';
import { Input } from 'components';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-full.svg';
import { useSelector } from 'react-redux';
import { IGroupPoolConfigDraft } from '../AdminEditGroupPoolConfigs';
import {selectAdminGroupPoolConfigs} from '../../../../store/slices/adminGroupPoolConfigsSlice';

interface IAdminAddGroupPoolConfigFormProps {
  config: IGroupPoolConfigDraft;
  onChange: (updated: IGroupPoolConfigDraft) => void;
}

export const AdminAddGroupPoolConfigForm = ({
  config,
  onChange,
}: IAdminAddGroupPoolConfigFormProps) => {
  const { t } = useTranslation();
  const [isDropdownCollapsed, setIsDropdownCollapsed] = useState(true);
  const { groupPoolConfigsAll } = useSelector(selectAdminGroupPoolConfigs);

  const handleChange =
    (field: keyof IGroupPoolConfigDraft) => (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ ...config, [field]: e.target.value });
    };

  const handleAlgorithmSelect = (value: number) => {
    onChange({ ...config, poolConfig: value });
    setIsDropdownCollapsed(true);
  };

  const selectedPoolConfigLabel =
      groupPoolConfigsAll.find((opt) => opt.id === config.poolConfig)?.name || '---';

  return (
    <StyledAdminAddGroupPoolConfigForm>
      <div className="form-select-wrapper">
        <div className="selected-group" onClick={() => setIsDropdownCollapsed((prev) => !prev)}>
          <div className="selected-group-name">{selectedPoolConfigLabel}</div>
          <div className={cn('drop-down-arrow', isDropdownCollapsed && 'collapsed')}>
            <ArrowDownIcon />
          </div>
        </div>
        {!isDropdownCollapsed && (
          <div className="custom-dropdown" onMouseLeave={() => setIsDropdownCollapsed(true)}>
              {groupPoolConfigsAll.map((opt) => (
                  <div
                      key={opt.id}
                      className="dropdown-option"
                      onClick={() => handleAlgorithmSelect(opt.id)}
                  >
                      {opt.name}
                  </div>
              ))}
          </div>
        )}
      </div>

      <Input
        placeholder={t('adminPage.editGroupPoolConfigs.formInputs.priorityOrder')}
        value={config.priority}
        onChange={handleChange('priority')}
      />

      <Input
        placeholder={t('adminPage.editGroupPoolConfigs.formInputs.connectionAttemps')}
        value={config.maxAttempts}
        onChange={handleChange('maxAttempts')}
      />

      {/*<Input*/}
      {/*  placeholder={t('adminPage.editGroupPoolConfigs.listHeaders.user')}*/}
      {/*  value={config.user}*/}
      {/*  onChange={handleChange('user')}*/}
      {/*/>*/}

      {/*<Input*/}
      {/*  placeholder={t('adminPage.editGroupPoolConfigs.listHeaders.password')}*/}
      {/*  value={config.password}*/}
      {/*  type="password"*/}
      {/*  onChange={handleChange('password')}*/}
      {/*/>*/}
    </StyledAdminAddGroupPoolConfigForm>
  );
};
